import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const temperatureScalesAdapter = getAdapter({ idFieldName: 'value' });

const temperatureScalesSlice = createSlice({
  name: 'temperatureScales',
  initialState: temperatureScalesAdapter.getInitialState(),
  reducers: {
    setTemperatureScales: (state, { payload: { temperatureScales } }) => {
      temperatureScalesAdapter.setAll(state, temperatureScales);
    },
  },
});

const selectors = temperatureScalesAdapter.getSelectors(({ temperatureScales }) => temperatureScales);

export const getTemperatureScales = (state) => selectors.selectAll(state);

export const {
  setTemperatureScales
} = temperatureScalesSlice.actions;

export default temperatureScalesSlice.reducer;